module.exports = __webpack_public_path__ + "img/fiskeri_akvakultur_paavirkning_eutrofiering.c4bf1a24.jpg";